import { render, staticRenderFns } from "./WishCity.vue?vue&type=template&id=61bf2c5e&scoped=true&"
import script from "./WishCity.vue?vue&type=script&lang=js&"
export * from "./WishCity.vue?vue&type=script&lang=js&"
import style0 from "./WishCity.vue?vue&type=style&index=0&id=61bf2c5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf2c5e",
  null
  
)

export default component.exports